import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { topics } from "@/utils/content";

export default function HomeTopics() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20" id="topics">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Topics"
          title="按专题慢慢扒"
          description="同一件事往往牵扯好几条线，我们用专题把相关的瓜串起来，方便你一次看明白。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              全部专题 <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to={`/news?topic=${topic.id}`}
              className="group relative block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
            >
              <div className="relative h-40 w-full overflow-hidden bg-background-200">
                <img
                  src={topic.image}
                  alt={`${topic.name}专题配图`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <h3 className="font-heading text-lg font-bold text-background-50">{topic.name}</h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs font-medium text-accent-700">{topic.slogan}</p>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {topic.description}
                </p>
                <p className="mt-3 text-xs text-foreground-500">共收录 {topic.count} 篇内容</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}